<template>
  <b-form @submit.prevent="submit">
    <b-form-group class="mt-4">
      <label>{{ $t('message.accountChangeEmailForm.label.currentEmail') }}</label>
      <b-form-input
        class="rounded-0 text-muted"
        :value="currentEmail"
        disabled>
      </b-form-input>
    </b-form-group>
    <b-form-group class="mt-4">
      <label>
        {{ $t('message.accountChangeEmailForm.label.email') }}
        <span class="text-danger">*</span>
      </label>
      <b-form-input
        class="rounded-0"
        v-model="email"
        :state="$v.email.$error ? false : null"
        @changed="$v.email.$touch()">
      </b-form-input>
    </b-form-group>
    <b-form-group
      class="mt-4"
      :state="$v.emailConfirm.$error ? false : null">
      <label>
        {{ $t('message.accountChangeEmailForm.label.emailConfirm') }}
        <span class="text-danger">*</span>
      </label>
      <b-form-input
        class="rounded-0"
        v-model="emailConfirm"
        :state="$v.emailConfirm.$error ? false : null"
        @changed="$v.emailConfirm.$touch()">
      </b-form-input>
    </b-form-group>
    <b-form-row class="mt-4">
      <b-col class="text-right">
        <b-btn variant="primary" type="submit">
          <span class="ti-save mr-2"></span>
          {{ $t('message.accountChangeEmailForm.btn.save') }}</b-btn>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
  import { email, required, sameAs } from 'vuelidate/lib/validators'
  export default {
    name: 'AccountChangeEmailForm',
    data () {
      return {
        email: null,
        emailConfirm: null
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$emit('submit', this.email)
        }
      },
      reset () {
        this.email = null
        this.emailConfirm = null
        this.$v.$reset()
      }
    },
    computed: {
      currentEmail () {
        return this.$store.getters.currentUser.email
      }
    },
    validations: {
      email: {
        required,
        email
      },
      emailConfirm: {
        required,
        sameAsEmail: sameAs('email')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/AccountChangeEmailForm.vue